/**
 * @generated SignedSource<<0a938b78373413842dbcbca5b72de7ad>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Article",
    "kind": "LinkedField",
    "name": "cmsArticles",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "thumbnailUrl",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "BlogListPageQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "BlogListPageQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "5273b437ba0fd9f254780a6032ad4c46",
    "id": null,
    "metadata": {},
    "name": "BlogListPageQuery",
    "operationKind": "query",
    "text": "query BlogListPageQuery {\n  cmsArticles {\n    id\n    title\n    thumbnailUrl\n  }\n}\n"
  }
};
})();

node.hash = "6d0f7509ab0962742f6114a4a7947f58";

module.exports = node;
